<div class="card">
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="form" nzTheme="outline"></i> Ministry
  </div>
  <div class="searchboxAerar p-3" style="background-color: #FFF;">
    <form nz-form [formGroup]="ministryForm" (ngSubmit)="submitForm()">
      <div class="form-row" style="margin-left: 12px">

        <div class="form-group col-md-6">
          <div class="form-group col-md-12">
            <nz-form-label nzRequired [nzSpan]="null">Ownership Type</nz-form-label>
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="furnitureNameErrorTpl"
              >
              <nz-select id="stpOwnershipType" nzShowSearch nzAllowClear formControlName="stpOwnershipType"
              nzPlaceHolder="Select one">
              <nz-option *ngFor="let stpOwnershipType of stpOwnershipType" [nzValue]="stpOwnershipType.id"
                [nzLabel]="stpOwnershipType.name">
              </nz-option>
            </nz-select>
                <ng-template #furnitureNameErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input quantity!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-6">
          <nz-form-label nzRequired style="margin-left: 10px"
            >Name of Ministry</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="furnitureNameErrorTpl"
              >
                <input
                  nz-input
                  formControlName="ministryName" pattern="^[^\s].+[^\s]$"
                  placeholder="Name of Ministry"
                  maxlength="255"
                />

                <ng-template #furnitureNameErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input valid name!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="form-group col-md-6">
          <div class="form-group col-md-12">
            <nz-form-label [nzSpan]="null"
              >Remarks</nz-form-label
            >
            <nz-form-item>
              <textarea
                  nz-input
                  formControlName="remarks"
                  placeholder="Remarks"
                  nzAutosize maxlength="255"
                >Remarks</textarea>
            </nz-form-item>
          </div>

        </div>


      </div>



      <div class="row justify-content-center media-button">
        <div class="col-md-3 col-sm-12 mt-2">
          <button
            type="submit"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            [disabled]="!ministryForm.valid"
          >
            <i nz-icon nzType="save" nzTheme="fill"></i> {{isEditMode?'Update':'Save'}}
          </button>
        </div>
        <div class="col-md-3 col-sm-12 mt-2">
          <button
            type="button"
            class="btn btn-danger active btn-lg btn-block cari border-redius"
            (click)="resetForm()"
          >
            <i nz-icon nzType="redo" nzTheme="outline"></i> Reset
          </button>
        </div>
      </div>
    </form>

  </div>



</div>
